module.exports = __webpack_public_path__ + "img/schedule20260919_2.57c3fade.jpg";